module.exports = __webpack_public_path__ + "static/service-e76309a35b250408e225cf637b51b8ee.png";